<template>
  <div
    aria-hidden="true"
    class="rf-inline-skeleton relative inline-block overflow-hidden after:absolute after:inset-0"
    :class="{ 'rf-inline-skelton--light': light }"
    :style="{
      '--rf-inline-skeleton--width': fullWidth
        ? '100%'
        : `${dynamic ? Math.floor(+width - +range + Math.random() * (+range * 2 + 1)) : width}px`,
      '--rf-inline-skeleton--height': fullHeight
        ? '100%'
        : `${dynamicHeight ? Math.floor(+height - +rangeHeight + Math.random() * (+rangeHeight * 2 + 1)) : height}px`,
      '--rf-inline-skeleton--border-radius': `${radius}px`,
    }"
  >
    <span v-if="srLabel" class="sr-only" role="status" aria-live="polite">{{ srLabel }}</span>
  </div>
</template>

<script setup>
defineProps({
  width: { type: [Number, String], default: 128 },
  height: { type: [Number, String], default: 16 },
  fullWidth: { type: Boolean, default: false },
  fullHeight: { type: Boolean, default: false },
  dynamic: { type: Boolean, default: false },
  range: { type: [Number, String], default: 20 },
  dynamicHeight: { type: Boolean, default: false },
  rangeHeight: { type: [Number, String], default: 20 },
  radius: { type: [Number, String], default: 8 },
  light: { type: Boolean, default: false },
  srLabel: { type: String, default: null },
});
</script>

<style lang="scss" scoped>
.rf-inline-skeleton.rf-inline-skelton--light {
  background-color: #fff;
  &:after {
    background: linear-gradient(90deg, #fff 10%, #eff2f5 50%, #fff 90%);
  }
}
.rf-inline-skeleton {
  background-color: #dfe1e4;
  width: var(--rf-inline-skeleton--width);
  height: var(--rf-inline-skeleton--height);
  border-radius: var(--rf-inline-skeleton--border-radius);

  &::after {
    content: "";
    transform: translateX(-100%);
    width: 200%;
    background: linear-gradient(90deg, #dfe1e4 10%, #eff2f5 50%, #dfe1e4 90%);
    animation: shimmer 2s infinite;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
